<template>
  <div class="authentication">
    <div class="auth">
      <form class="form" v-on:submit.prevent="submitForm">
        <img class="logo" src="logo.svg">
        <div class="header">Bienvenido</div>
        <div class="subtitle">Inicia sesión para continuar</div>
        <label for="email" class="input-label">
          Correo:
          <input type="text" class="input" id="email" v-model="email">
        </label>
        <label for="password" class="input-label">
          <div class="password-label">
            Contraseña: <span @click="togglePassword">{{ passwordShowButton }}</span>
          </div>
          <input :type="passwordFieldType" class="input" id="password" v-model="password">
        </label>
        <div class="button-wrapper">
          <input type="submit" class="button" value="Iniciar sesión">
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('user');

export default {
  data() {
    return {
      email: '',
      password: '',
      passwordFieldType: 'password',
      passwordShowButton: 'mostrar contraseña',
    };
  },
  methods: {
    togglePassword() {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text';
        this.passwordShowButton = 'ocultar contraseña';
      } else {
        this.passwordFieldType = 'password';
        this.passwordShowButton = 'mostrar contraseña';
      }
    },
    redirect(user) {
      if (user.permissions === 'SELLER') {
        this.$router.push('/home');
      } else if (user.permissions === 'STORE') {
        this.$router.push('/store');
      } else if (user.permissions === 'CORPORATE') {
        this.$router.push('/corporate');
      }
    },
    submitForm() {
      this.login({
        email: this.email,
        password: this.password,
      }).then(() => {
        this.getUser().then((user) => {
          this.redirect(user);
        });
      });
    },
    ...mapActions([
      'login',
      'getUser',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.authentication {
  width: 100vw;
  height: 100vh;
  display: flex;
  background-color: aliceblue;
  background-image: url('/background.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.auth {
  width: 50%;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.logo {
  width: 200px;
  height: auto;
  margin-left: -10px;
}
.form {
  padding: 0 20px;
  width: 400px;
  max-width: 90%;
  margin-top: -50px;
}
.input-label {
  display: flex;
  flex-direction: column;
  margin: 16px 0;
}
.input {
  color: #5f6368;
  margin-top: 8px;
  border: 1px solid #DCDEDD;
  border-radius: 4px;
  padding: 12px;

  &:focus {
    border: 1px solid #f79916;
  }
}
.header {
  font-size: 32px;
  margin-top: 20px;
}
.subtitle {
  margin-bottom: 30px;
  margin-top: 10px;
}
.button-wrapper {
  display: flex;
  justify-content: flex-end;
}
.button {
  background-color: #f79916;
  padding: 10px 24px;
  color: white;
  border-radius: 4px;
  margin: 10px 0;
}
span {
  color: #f79916;
  cursor: pointer;
}
.password-label {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 920px) {
  .auth {
    width: 100%;
  }
}
</style>
